import React, { useState } from 'react';
import './categoriatoggle.css'; // Importa el archivo CSS para estilos

const ToggleSwitch = ({isAcademic, setIsAcademic, inventario}) => {

  const toggleSwitch = () => {
    setIsAcademic(!isAcademic);
  }

  return (
    <div className="toggle-switch" onClick={toggleSwitch} style={inventario && {margin: '0px', height: '32px'}}>
      <div className={`slider ${!isAcademic ? 'right' : ''}`}></div>
      <div className="label left" style={isAcademic ? {color: 'white'} : {color: '#f98806'} }>{inventario ? 'Libros' : 'Académico'}</div>
      <div className="label right" style={!isAcademic ? {color: 'white'} : {color: '#f98806'} }>{inventario ? 'Autores' :  'Literatura'}</div>
    </div>
  );
}

export default ToggleSwitch;